var map = {
	"./american-names.json": 138,
	"./bbc-ggj.json": 447,
	"./drawing-prompts.json": 803,
	"./dungeons.json": 786,
	"./game-pieces.json": 897,
	"./honey-heist.json": 364,
	"./simple-meals.json": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 841;